import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MapIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38L3 20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62L21 3.5C21 3.22 20.78 3 20.5 3ZM10 5.47L14 6.87L14 18.53L10 17.13L10 5.47ZM5 6.46L8 5.45L8 17.15L5 18.31L5 6.46ZM19 17.54L16 18.55L16 6.86L19 5.7L19 17.54Z"
      fill="currentColor"
    />
  </svg>
);

MapIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MapIcon);
